import { motion } from "framer-motion";

/**
 * Animates a string word-by-word with a staggered fade + slide-up on enter.
 * Splits on whitespace and renders each word in its own span so the reveal
 * mask reads naturally regardless of font / size.
 */
export default function StaggerWords({
  text,
  as = "span",
  className = "",
  delay = 0,
  stagger = 0.07,
  duration = 0.7,
  italic = false,
  italicClassName = "",
}) {
  const Tag = motion[as] || motion.span;
  const words = String(text || "").split(/\s+/).filter(Boolean);

  return (
    <Tag
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-15%" }}
      transition={{ staggerChildren: stagger, delayChildren: delay }}
    >
      {words.map((w, i) => (
        <span
          key={i}
          className="inline-block overflow-hidden align-baseline mr-[0.25em] last:mr-0"
        >
          <motion.span
            className={`inline-block ${italic ? italicClassName : ""}`}
            variants={{
              hidden: { y: "110%", opacity: 0 },
              show: {
                y: "0%",
                opacity: 1,
                transition: { duration, ease: [0.22, 1, 0.36, 1] },
              },
            }}
          >
            {w}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
